<template>
    <div>
        <!-- <div class="biaoqian">全部功能</div> -->
        <div class="indexbg2">
            <el-card class="star" shadow="never" style="background: linear-gradient(133deg, #a976ff 21%, #ff7676);">
                <div style="color: #fff;font-size: 20px;font-weight: 600;margin-bottom: 20px;">首次使用</div>

                <el-row :gutter="20">
                    <el-col :xs="24" :sm="12" :lg="6" style="padding: 15px 15px 0px 15px;">
                        <el-card style="border-radius:10px;border: 0px;box-shadow: 0 4px 21px 0 rgb(115 149 255 / 24%);"
                            shadow="never">
                            <div style="display: flex;justify-content: space-between;cursor: pointer;"
                                @click="kf = true">
                                <div>
                                    <div style="font-weight: 600;font-size: 17px;">专属客服</div>
                                    <div style="font-size: 13px;margin-top: 2px;color: #385fe1;">立即添加</div>
                                </div>

                                <el-avatar icon="el-icon-service" :size="50"
                                    style="font-size: 35px;background-color: #3d5ee3;;"></el-avatar>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :xs="24" :sm="12" :lg="6" style="padding: 15px 15px 0px 15px;">
                        <el-card style="border-radius:10px;border: 0px;box-shadow: 0 4px 21px 0 rgb(115 149 255 / 24%);"
                            shadow="never">
                            <div style="display: flex;justify-content: space-between;cursor: pointer;"
                                @click="star('/user/vip')">
                                <div>
                                    <div style="font-weight: 600;font-size: 17px;">开通会员</div>
                                    <div style="font-size: 13px;margin-top: 2px;color: #385fe1;">立即开始</div>
                                </div>

                                <el-avatar icon="el-icon-s-shop" :size="50"
                                    style="font-size: 35px;background-color: #d64646;"></el-avatar>
                            </div>
                        </el-card>
                    </el-col>
                    <!-- <el-col :xs="24" :sm="12" :lg="6" style="padding: 15px 15px 0px 15px;">
                        <el-card style="border-radius:10px;border: 0px;box-shadow: 0 4px 21px 0 rgb(115 149 255 / 24%);"
                            shadow="never">

                            <div style="display: flex;justify-content: space-between;cursor: pointer;" @click="ios_app">
                                <div>
                                    <div style="font-weight: 600;font-size: 17px;">苹果APP</div>
                                    <div style="font-size: 13px;margin-top: 2px;color: #385fe1;">立即下载</div>
                                </div>

                                <el-image style="width: 40px;padding: 11px;background-color: #333;border-radius: 30px;"
                                    :src="require('@/assets/img/apple.png')"></el-image>
                            </div>
                        </el-card>
                    </el-col> -->
                    <el-col :xs="24" :sm="12" :lg="6" style="padding: 15px 15px 0px 15px;">
                        <el-card style="border-radius:10px;border: 0px;box-shadow: 0 4px 21px 0 rgb(115 149 255 / 24%);"
                            shadow="never">
                            <div style="display: flex;justify-content: space-between;cursor: pointer;" @click="downapp">
                                <div>
                                    <div style="font-weight: 600;font-size: 17px;">苹果/安卓APP</div>
                                    <div style="font-size: 13px;margin-top: 2px;color: #385fe1;">立即下载</div>
                                </div>

                                <el-avatar icon="el-icon-mobile" :size="50"
                                    style="font-size: 35px;background-color: #444;"></el-avatar>
                            </div>
                        </el-card>
                    </el-col>

                </el-row>
            </el-card>
            <div style="height: 20px;"></div>

        </div>
        <div class="indexbg">
            <el-card class="star" shadow="never">
                <div style="color: #fff;font-size: 20px;font-weight: 600;margin-bottom: 20px;">创作工具！</div>
                <el-row :gutter="20">
                    <el-col :xs="24" :sm="12" :lg="6" style="padding: 15px 15px 0px 15px;">
                        <el-card style="border-radius:10px;border: 0px;" shadow="never">
                            <div style="display: flex;justify-content: space-between;cursor: pointer;"
                                @click="star('/user/qc')">
                                <div>
                                    <div style="font-weight: 600;font-size: 17px;">一键去重</div>
                                    <div style="font-size: 13px;margin-top: 2px;color: #385fe1;">立即开始</div>
                                </div>

                                <el-image style="width: 50px;" :src="require('@/assets/img/zxzz.png')"></el-image>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :xs="24" :sm="12" :lg="6" style="padding: 15px 15px 0px 15px;">
                        <el-card style="border-radius:10px;border: 0px;" shadow="never">
                            <div style="display: flex;justify-content: space-between;cursor: pointer;"
                                @click="star('/user/hj')">
                                <div>
                                    <div style="font-weight: 600;font-size: 17px;">混剪去重</div>
                                    <div style="font-size: 13px;margin-top: 2px;color: #385fe1;">立即开始</div>
                                </div>

                                <el-image style="width: 50px;" :src="require('@/assets/img/hj.png')"></el-image>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :xs="24" :sm="12" :lg="6" style="padding: 15px 15px 0px 15px;">
                        <el-card style="border-radius:10px;border: 0px;" shadow="never">
                            <div style="display: flex;justify-content: space-between;cursor: pointer;"
                                @click="star('/user/haowu')">
                                <div>
                                    <div style="font-weight: 600;font-size: 17px;">聚合好物</div>
                                    <div style="font-size: 13px;margin-top: 2px;color: #385fe1;">立即开始</div>
                                </div>

                                <el-image style="width: 50px;" :src="require('@/assets/img/ku.png')"></el-image>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :xs="24" :sm="12" :lg="6" style="padding: 15px 15px 0px 15px;">
                        <el-card style="border-radius:10px;border: 0px;" shadow="never">
                            <div style="display: flex;justify-content: space-between;cursor: pointer;"
                                @click="star('/user/ku')">
                                <div>
                                    <div style="font-weight: 600;font-size: 17px;">混剪协同</div>
                                    <div style="font-size: 13px;margin-top: 2px;color: #385fe1;">立即开始</div>
                                </div>

                                <el-avatar icon="el-icon-sort" :size="50"
                                    style="font-size: 35px;background-color: #444;"></el-avatar>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :xs="24" :sm="12" :lg="6" style="padding: 15px 15px 0px 15px;">
                        <el-card style="border-radius:10px;border: 0px;" shadow="never">
                            <div style="display: flex;justify-content: space-between;cursor: pointer;"
                                @click="star('/user/qsy')">
                                <div>
                                    <div style="font-weight: 600;font-size: 17px;">去水映/提取素材</div>
                                    <div style="font-size: 13px;margin-top: 2px;color: #385fe1;">立即使用</div>
                                </div>

                                <el-avatar :size="49" :src="require('@/assets/img/qsy.png')"
                                    style="padding: 9px;background-color: #444;"></el-avatar>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>
            </el-card>


        </div>

        <div class="indexbg2" style="margin-top: 20px;">
            <el-card class="star" shadow="never">
                <div style="color: #333;font-size: 20px;font-weight: 600;margin-bottom: 20px;">可能需要</div>
                <el-row :gutter="20">

                    <el-col :xs="24" :sm="12" :lg="6" style="padding: 15px 15px 0px 15px;" v-if="have_share">
                        <el-card style="border-radius:10px;border: 0px;box-shadow: 0 4px 21px 0 rgb(115 149 255 / 24%);"
                            shadow="never">
                            <div style="display: flex;justify-content: space-between;cursor: pointer;"
                                @click="star('/user/share')">
                                <div>
                                    <div style="font-weight: 600;font-size: 17px;">邀请返利</div>
                                    <div style="font-size: 13px;margin-top: 2px;color: #385fe1;">立即开始</div>
                                </div>

                                <el-avatar icon="el-icon-share" :size="50"
                                    style="font-size: 35px;background-color: rgb(104 200 7);"></el-avatar>
                            </div>
                        </el-card>
                    </el-col>

                    <el-col :xs="24" :sm="12" :lg="6" style="padding: 15px 15px 0px 15px;" v-if="uploadTutorial">
                        <el-card style="border-radius:10px;border: 0px;box-shadow: 0 4px 21px 0 rgb(115 149 255 / 24%);"
                            shadow="never">
                            <div style="display: flex;justify-content: space-between;cursor: pointer;"
                                @click="star('/user/upload_tutorial')">
                                <div>
                                    <div style="font-weight: 600;font-size: 17px;">上传教程</div>
                                    <div style="font-size: 13px;margin-top: 2px;color: #385fe1;">立即上传</div>
                                </div>

                                <el-avatar icon="el-icon-upload" :size="50"
                                    style="font-size: 35px;background-color: rgb(241, 147, 24);"></el-avatar>
                            </div>
                        </el-card>
                    </el-col>

                    <el-col :xs="24" :sm="12" :lg="6" style="padding: 15px 15px 0px 15px;" v-if="developer">
                        <el-card style="border-radius:10px;border: 0px;box-shadow: 0 4px 21px 0 rgb(115 149 255 / 24%);"
                            shadow="never">
                            <div style="display: flex;justify-content: space-between;cursor: pointer;"
                                @click="$router.push('/user/developer')">
                                <div>
                                    <div style="font-weight: 600;font-size: 17px;">开发者</div>
                                    <div style="font-size: 13px;margin-top: 2px;color: #385fe1;">立即开始</div>
                                </div>

                                <el-avatar icon="el-icon-magic-stick" :size="50"
                                    style="font-size: 35px;background-color: #333;"></el-avatar>
                            </div>
                        </el-card>
                    </el-col>

                </el-row>
            </el-card>
            <div style="height: 50px;"></div>
        </div>

        <el-dialog :visible.sync="share" custom-class="newdialog_share">
            <!-- <el-image style="width: 100%;" :src="require('@/assets/share.jpg')"></el-image> -->
            <div style="margin-top: 20px;">
                <div style="margin-bottom: 10px;">邀请链接</div>
                <el-input size="medium" v-model="share_url" disabled></el-input>
                <div style="display: flex;justify-content: space-between;align-items: center;">
                    <div style="font-size: 13px;display: flex;align-items: center;">已邀请{{ share_num }}人,邀请奖励余额:{{
                        share_yqfl
                        }}元<el-link type="danger" style="font-size: 13px;margin-left: 3px;"
                            v-if="share_yqfl > 100">提现</el-link></div>
                    <!-- <el-checkbox v-model="share_look">对邀请的用户隐藏邀请返利</el-checkbox> -->
                    <div>

                        <el-button type="success" size="medium" style="margin-top: 15px;" @click="copy(share_url)">一键复制
                        </el-button>
                    </div>

                </div>

            </div>
            <el-table :data="share_orderdata" stripe style="width: 100%;margin-top: 10px;" size="mini">
                <el-table-column prop="username" label="用户" :formatter="user_jm">
                </el-table-column>
                <el-table-column prop="upid_fl_money" label="奖励金额(元)">
                </el-table-column>
                <el-table-column prop="time" label="日期" :formatter="formatDate">
                </el-table-column>
            </el-table>
            <el-pagination small layout="prev, pager, next" :page-size="5" :total="total" @current-change="fy_page"
                :current-page="share_page" style="margin-top: 20px;">
            </el-pagination>
        </el-dialog>
        <el-dialog :visible.sync="kf" custom-class="newdialog_share">
            <div style="display: flex;justify-content: center;flex-wrap: wrap;">
                <el-image style="width: 50%;" src="https://video.kissxx.cn/siyokf_new.png"></el-image>

            </div>
            <div style="text-align: center;">微信扫一扫</div>
            <div style="text-align: center;">添加专属客服、进群交流学习</div>


        </el-dialog>

        <div hidden>


            <!-- <div>
                <el-row :gutter="20">
                    <el-col :sm="6">
                        <el-card class="box-card" style="border-radius:10px;margin-top: 20px;background-color: rgb(4 46 143 / 75%);color: #fff;" shadow="never">
                            <div style="display:flex;flex-direction:column;">
                                <div style="text-align:center;">可用通道</div>
                                <div style="text-align:center;margin-top: 10px;font-size: 20px">{{fwqnum}}</div>
                            </div>
                            
                        </el-card>
                    </el-col>
                    <el-col :sm="6">
                        <el-card class="box-card" style="border-radius:10px;margin-top: 20px;background-color: rgb(156 19 19 / 75%);color: #fff;" shadow="never">
                            <div style="display:flex;flex-direction:column;">
                                <div style="text-align:center;">任务数量</div>
                                <div style="text-align:center;margin-top: 10px;font-size: 20px">{{fwqrw}}</div>
                            </div>
                            
                        </el-card>
                    </el-col>
                </el-row>
            </div> -->

            <!-- <div class="biaoqian">接口信息</div>
            <el-card class="box-card" style="border-radius:10px;" shadow="never">
                <div style="margin: 10px 0px;">
                    <div style="display: flex;align-items: center;flex-wrap: wrap;">
                        <div style="width: 70px;margin-right:10px;">uid:</div>
                        <div style="width: 400px;">
                            <el-input placeholder="未获取到" v-model="uid" :disabled="true">
                            </el-input>
                        </div>
                    </div>
                    <div style="display: flex;align-items: center;margin-top: 20px;flex-wrap: wrap;">
                        <div style="width: 70px;margin-right:10px;">key:</div>
                        <div style="width: 400px;">
                            <el-input placeholder="未获取到" v-model="key" :disabled="true">
                            </el-input>
                        </div>
                        <div style="margin-left: 5px;">
                            <el-link type="primary">更换Key</el-link>
                        </div>
                    </div>

                    <div style="display: flex;align-items: center;margin-top: 20px;flex-wrap: wrap;">
                        <div style="width: 70px;margin-right:10px;">接口文档:</div>
                        <div style="width: 400px;">
                            <el-input placeholder="未获取到" v-model="wd" :disabled="true">
                            </el-input>
                        </div>
                        <div style="margin-left: 5px;">
                            <el-link type="" @click="openurl(wd)">点击打开</el-link>
                        </div>
                    </div>

                    <div style="display: flex;align-items: center;margin-top: 20px;flex-wrap: wrap;">
                        <div style="width: 70px;margin-right:10px;">通道数量:</div>
                        <el-tag size="small">{{fwqnum}}</el-tag>

                    </div>
                </div>

            </el-card> -->
        </div>
        <div v-if="wx" class="wx">
            <div style="position: absolute;right: 0;">
                <div style="display: flex;justify-content: end;margin: 10px 30px 0px 0px;">
                    <i class="el-icon-top-right" style="font-size: 40px;color: #fff;"></i>

                </div>
                <div style="color: #fff;font-size: 27px;margin:20px 40px 0px 0px;">点击右上角 ···<br>在手机浏览器中打开</div>
            </div>

        </div>
    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
export default {
    name: '',
    components: {},
    // 定义属性
    data() {
        return {
            cleartime: 0,
            uploadTutorial: false,
            timer: '',
            calltoday: '',
            surplus: '',
            uid: '',
            key: '',
            jkurl: '',
            hz: '',
            wd: 'https://console-docs.apipost.cn/preview/af8f843759895d62/63928064064d7425',
            fwqnum: 0,
            fwqrw: 0,
            vip: false,
            have_share: false,
            share: false,
            share_url: '',
            share_look: false,
            share_orderdata: [],
            share_page: 1,
            share_num: 0,
            share_yqfl: 0,
            total: 0,
            kf: false,
            developer: false,
            wx: false
        }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        formatDate(row) {
            let date = new Date(row['time'] * 1000);
            // console.log(date);
            // console.log(row);
            // console.log(row['intime']);
            let Y = date.getFullYear() + '-';
            let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-';
            let D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ';
            let h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
            let m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
            let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
            return Y + M + D + h + m + s;
        },
        user_jm(row) {
            var newname = row['username'].substring(0, 2) + '****';
            return newname
        },
        ios_app() {
            window.open('https://apps.apple.com/cn/app/%E8%B5%B7%E5%8F%B7%E4%BA%91/id1609731577');
        },
        an_app() {
            window.open('https://spk.siyoa.com/qhy/app/update/duoheios/2.2.0/duohe_v2.apk');
        },
        downapp() {
            if (/(micromessenger)/i.test(navigator.userAgent)) {
                this.wx = true
                return
            }

            if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
                location.href = 'https://apps.apple.com/cn/app/%E5%A4%9A%E5%90%88%E5%89%AA%E8%BE%91/id6748834540'
            } else {
                location.href = 'https://spk.siyoa.com/qhy/app/update/duoheios/2.2.0/duohe_v2.apk'
            }
        },
        share_fc() {
            this.share_order()
            this.share = true
        },
        fy_page(e) {
            this.share_page = e
            this.share_order()
        },
        share_order() {
            // 邀请链接与文案由后端统一返回（可随时控制域名/文案/格式）
            this.$ajax.get('api/v1/users/share/url').then(res => {
                if (res.data && res.data.status == 200 && res.data.data && res.data.data.text) {
                    this.share_url = res.data.data.text
                }
            }).catch(error => {
                console.error('获取邀请链接失败:', error)
            })
            this.$ajax.get('qhy/user/fl_order?page=' + this.share_page).then(res => {
                // console.log(res.data)
                var jg = res.data
                if (res.data.status == 200) {
                    this.share_orderdata = jg.fl_list.data
                    this.total = jg.fl_list.total
                    this.share_yqfl = jg.info.yqfl
                    this.share_num = jg.info.num
                }

            })
        },
        star(url) {

            this.$router.push(url)
            if (url == '/user/qsy') {
                return
            }
            this.$parent.$parent.$parent.$parent.getCurrentMenu()
        },
        hy() {
            this.$parent.$parent.$parent.$parent.dyhy()

        },
        // get_user() {
        //     const loading = this.$loading(this.$loadinginfo);
        //     this.$ajax.get('qhy/user/developer').then(res => {
        //         // console.log(res.data)
        //         var jg = res.data
        //         if (res.data.status == 200) {
        //             this.calltoday = jg.data.calltoday

        //             if (jg.data.surplus > 160000) {
        //                 var sysj = jg.data.surplus - new Date().getTime() / 1000
        //                 this.surplus = parseInt(sysj / 86400) + '天'
        //             } else {
        //                 this.surplus = jg.data.surplus
        //             }
        //             this.uid = jg.data.uid
        //             this.key = jg.data.key
        //             this.jkurl = jg.data.jkurl
        //             this.hz = jg.data.hz
        //             this.fwqnum = jg.data.fwqnum
        //             this.fwqrw = jg.data.fwqrw
        //             // this.$msg.success(res.data.msg)
        //         } else {
        //             this.$router.push('/login')
        //         }
        //         loading.close();
        //     })
        // },
        get_td() {
            console.log('123')
        },
        copy(context) {
            let oInput = document.createElement('textarea');
            // 分享文案+链接由后端返回（已含 sk 参数），原样复制
            oInput.value = context;
            // 页面底部追加输入框
            document.body.appendChild(oInput);
            // 选中输入框
            oInput.select();
            // 执行浏览器复制命令
            document.execCommand('Copy');
            // 弹出复制成功信息
            this.$message.success('复制成功');
            // 复制后移除输入框
            oInput.remove();
        },
        openurl(e) {
            window.open(e, "_blank");
        }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
        // var user_share_look = localStorage.getItem('share_look')
        // if (user_share_look == true) {
        //     this.have_share = false
        // } else {
        //     this.have_share = true
        // }
        this.have_share = true
        var userinfo = window.sessionStorage.getItem('userinfo')
        if (userinfo) {
            var info = JSON.parse(userinfo)
            this.uploadTutorial = info.upload_tutorial
            this.developer = info.developer
        }
        // this.get_user()
        // this.cleartime = 0
        // this.timer = setInterval(() => {
        //     //需要定时执行的代码
        //     if (this.cleartime == 1) {
        //         clearInterval(this.timer);
        //         this.timer = null;
        //     } else {
        //         this.get_td()
        //     }

        // }, 5000)
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { }, // 生命周期 - 创建之前
    beforeMount() { }, // 生命周期 - 挂载之前
    beforeUpdate() { }, // 生命周期 - 更新之前
    updated() { }, // 生命周期 - 更新之后
    beforeDestroy() { }, // 生命周期 - 销毁之前
    destroyed() { this.cleartime = 1 }, // 生命周期 - 销毁完成
    activated() { }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style>
.indexbg .star {
    border-radius: 10px;
    border: 0px;
    background: linear-gradient(133deg, #6e57f3 21%, #385fe1);
}

.indexbg2 .star {
    border-radius: 10px;
    border: 0px;
    /* background: linear-gradient(133deg, #57a5f3 21%, #385fe1); */
    background-color: #fff;

}

.wx {
    position: fixed;
    z-index: 9999;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(61, 61, 61, 0.6);
}
</style>


// WEBPACK FOOTER //
// src/components/User/Index.vue


// WEBPACK FOOTER //
// src/components/User/Index.vue